import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {computed} from 'vue';
import CoreUiAvatar from "~/core-ui/vue/chat/CoreUiAvatar.vue";
import OperatorApplicationPlatformIcon from "~/operatorApplication/vue/misc/OperatorApplicationPlatformIcon.vue";


const __default__ = {
    name: "CoreUiChatClientAvatar"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    client: {},
    size: {},
    showStatus: { type: Boolean },
    integrationPlatform: {},
    showLetters: { type: Boolean, default: true },
    alwaysOnline: { type: Boolean }
  },
  setup(__props: any) {

let props = __props;


let isRealAvatar = computed(() => {
    return props.client.avatar.isReal && !!props.client.avatar.url;
});




let background = computed(() => {
    if (props.integrationPlatform) {
        if (props.integrationPlatform.iconImg) {
            return '#ffffff';
        } else {
            return props.integrationPlatform.iconColor;
        }
    }
    let client = props.client;
    return client.status || client.integration || props.alwaysOnline ? client.avatar.background : undefined;
});

let avatarBackground = computed(() => {
    if (props.integrationPlatform) {
        return props.client.avatar.background ?? props.integrationPlatform.iconColor;
    }
    return background.value;
})

let statusColor = computed(() => {
    if (props.showStatus && !props.client.integration && props.client.status) {
        if (props.client.status) {
            if (props.client.isOnTab) {
                return '#1abc9c';
            } else {
                return '#f39c12';
            }
        }
        return '#95a5a6';
    } else {
        return undefined;
    }
});

let name = computed(() => {
    if (!props.client.isDescrStandart) {
        let descr = props.client.fields.descr;
        if (typeof descr == "string") {
            return descr;
        }
    }
    return undefined;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CoreUiAvatar, {
    size: __props.size,
    src: __props.client.avatar.url,
    name: _unref(isRealAvatar) ? null : _unref(name),
    background: _unref(avatarBackground),
    "status-color": _unref(statusColor),
    "plat-form": __props.integrationPlatform && !_unref(isRealAvatar) ? __props.integrationPlatform : null
  }, _createSlots({ _: 2 }, [
    (__props.integrationPlatform)
      ? {
          name: "append",
          fn: _withCtx(() => [
            _createElementVNode("span", {
              class: "icon-wrapper",
              style: _normalizeStyle({background: _unref(background)})
            }, [
              _createVNode(OperatorApplicationPlatformIcon, {
                class: "icon",
                platform: __props.integrationPlatform
              }, null, 8, ["platform"])
            ], 4)
          ]),
          key: "0"
        }
      : undefined,
    (_ctx.$slots.badge)
      ? {
          name: "badge",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "badge")
          ]),
          key: "1"
        }
      : undefined
  ]), 1032, ["size", "src", "name", "background", "status-color", "plat-form"]))
}
}

})